import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import PublicLayout from "@/components/site/PublicLayout";
import AdminLayout from "@/components/site/AdminLayout";

import HomePage from "@/pages/public/HomePage";
import { MeditationEnlightenmentPage, BlissPathPage, AuraNightPage, OneToOnePage } from "@/pages/public/ProgramPages";
import { TestimonialsPage, AboutPage, ContactPage } from "@/pages/public/StaticPages";
import ThankYouPage from "@/pages/public/ThankYouPage";
import MeditationsPage from "@/pages/public/MeditationsPage";
import MeditationProductPage from "@/pages/public/MeditationProductPage";
import MeditationPurchasePage from "@/pages/public/MeditationPurchasePage";
import MeditationAccessPage from "@/pages/public/MeditationAccessPage";
import MeditationsAdminPage from "@/pages/admin/MeditationsAdminPage";
import HomepageFeaturedAdminPage from "@/pages/admin/HomepageFeaturedAdminPage";

import LoginPage from "@/pages/admin/LoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import BookingsPage from "@/pages/admin/BookingsPage";
import JourneysPage from "@/pages/admin/JourneysPage";
import ProgramsPage from "@/pages/admin/ProgramsPage";
import TestimonialsAdminPage from "@/pages/admin/TestimonialsAdminPage";
import EmailTemplatesPage from "@/pages/admin/EmailTemplatesPage";
import { PaymentLogsPage, EmailLogsPage } from "@/pages/admin/LogsPages";
import { ReportsPage, SettingsPage } from "@/pages/admin/ExtraAdminPages";

function ProtectedAdmin() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grain-bg flex items-center justify-center text-[#7E736E]">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace/>;
  return <Outlet/>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout/>}>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/meditation-enlightenment" element={<MeditationEnlightenmentPage/>}/>
            <Route path="/bliss-path" element={<BlissPathPage/>}/>
            <Route path="/aura-night" element={<AuraNightPage/>}/>
            <Route path="/one-to-one" element={<OneToOnePage/>}/>
            <Route path="/testimonials" element={<TestimonialsPage/>}/>
            <Route path="/about" element={<AboutPage/>}/>
            <Route path="/contact" element={<ContactPage/>}/>
            <Route path="/thank-you/:id" element={<ThankYouPage/>}/>
            <Route path="/meditations" element={<MeditationsPage/>}/>
            <Route path="/meditations/purchase/:id" element={<MeditationPurchasePage/>}/>
            <Route path="/meditations/access/:token" element={<MeditationAccessPage/>}/>
            <Route path="/meditations/:slug" element={<MeditationProductPage/>}/>
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<LoginPage/>}/>
          <Route element={<ProtectedAdmin/>}>
            <Route element={<AdminLayout/>}>
              <Route path="/admin" element={<DashboardPage/>}/>
              <Route path="/admin/bookings" element={<BookingsPage/>}/>
              <Route path="/admin/journeys" element={<JourneysPage/>}/>
              <Route path="/admin/programs" element={<ProgramsPage/>}/>
              <Route path="/admin/testimonials" element={<TestimonialsAdminPage/>}/>
              <Route path="/admin/meditations" element={<MeditationsAdminPage/>}/>
              <Route path="/admin/homepage" element={<HomepageFeaturedAdminPage/>}/>
              <Route path="/admin/email-templates" element={<EmailTemplatesPage/>}/>
              <Route path="/admin/payment-logs" element={<PaymentLogsPage/>}/>
              <Route path="/admin/email-logs" element={<EmailLogsPage/>}/>
              <Route path="/admin/reports" element={<ReportsPage/>}/>
              <Route path="/admin/settings" element={<SettingsPage/>}/>
            </Route>
          </Route>
        </Routes>
        <Toaster richColors closeButton position="top-right"/>
      </BrowserRouter>
    </AuthProvider>
  );
}
